import { useEffect } from "react";

function ClearCache() {
    useEffect(() => {
        // Clear localStorage
        localStorage.clear();

        // Clear sessionStorage
        sessionStorage.clear();

        // Clear Cache Storage
        if ("caches" in window) {
            caches.keys().then((names) => {
                names.forEach((name) => {
                    caches.delete(name);
                });
            });
        }

        // Unregister service workers
        if ("serviceWorker" in navigator) {
            navigator.serviceWorker.getRegistrations().then((registrations) => {
                registrations.forEach((registration) => {
                    registration.unregister();
                });
            });
        }

        // Reload
        window.location.href = "/";
    }, []);

    return <p>Clearing cache...</p>;
}

export default ClearCache;